"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECivilityTrads = void 0;
exports.ECivilityTrads = {
    monsieur: "Monsieur",
    madame: "Madame",
    non_communique: "Non communiqué",
};
